import {Component, Input, Output, EventEmitter, ViewEncapsulation} from '@angular/core';
import {colorToVar} from '../cml-types';

@Component({
  selector: 'cml-header',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="headerconfTpl boc-page-header">
      <div class="cml-header__row1">
        <div class="btnsaveL ui-btn--primary" [class.btnsaveLoff]="!hasChanges || saving" (click)="saveClick.emit()">
          @if (saving) {
            Sauvegarde en cours...
          } @else {
            <i class="fas fa-save"></i>&nbsp; Sauvegarder
          }
        </div>
        @if (hasChanges) {
          <div class="blocmodifL">
            {{ changeCount }} modification{{ changeCount > 1 ? 's' : '' }} non-sauvegardée{{ changeCount > 1 ? 's' : '' }}
            <span class="annulmod" (click)="cancelClick.emit()"><i class="fa-solid fa-xmark"></i></span>
          </div>
        }
        <label class="ui-switch filterPast" [title]="hidePastEvents ? 'Afficher aussi les événements passés' : 'Masquer les événements passés'">
          <input type="checkbox" class="ui-switch__input"
                 [checked]="!hidePastEvents"
                 (change)="togglePast.emit()">
          <span class="filterPastTxt">Événements passés</span>
          @if (pastEventsCount > 0) {
            <span class="filterPastCount">{{ pastEventsCount }}</span>
          }
        </label>
        <div class="search-area">
          <div class="searchic"><i class="fal fa-search"></i></div>
          <input type="text"
                 placeholder="Rechercher un tarif"
                 class="searchTpl"
                 autocomplete="off"
                 [value]="searchTerm"
                 (input)="searchChange.emit($any($event.target).value)">
          @if (searchTerm) {
            <div class="cleanSearch" (click)="clearSearch.emit()"><i class="fas fa-times-circle"></i></div>
          }
        </div>
      </div>
      @if (availableLabels.length > 0 || availableSchedules.length > 0) {
        <div class="cml-header__row2">
          @if (availableLabels.length > 0) {
            <div class="label-filter">
              @for (item of availableLabels; track item.label) {
                <button class="label-chip"
                        [class.label-chip--active]="isLabelSelected(item.label)"
                        (click)="toggleLabel.emit(item.label)">
                  @if (item.color) {
                    <span class="label-chip__dot" [style.background-color]="colorToVar(item.color)"></span>
                  }
                  {{ item.label }}
                  <span class="label-chip__count">{{ item.count }}</span>
                </button>
              }
            </div>
          }
          @if (availableSchedules.length > 0) {
            <div class="schedule-filter">
              <button class="schedule-now-toggle"
                      [class.schedule-now-toggle--active]="nowModeActive"
                      (click)="toggleNowMode.emit()">
                <i class="far fa-clock"></i> Maintenant
              </button>
              @if (!nowModeActive) {
                <select class="schedule-select"
                        [value]="selectedSchedule || ''"
                        (change)="selectSchedule.emit($any($event.target).value || null)">
                  <option value="">Tous créneaux</option>
                  @for (sched of availableSchedules; track sched.key) {
                    <option [value]="sched.key">{{ sched.label }}</option>
                  }
                </select>
              }
            </div>
          }
        </div>
      }
      @if (hiddenPastSearchCount > 0) {
        <div class="hiddenResultsBanner" (click)="showPastResults.emit()">
          <i class="far fa-info-circle"></i>&nbsp;
          {{ hiddenPastSearchCount }} résultat{{ hiddenPastSearchCount > 1 ? 's' : '' }} dans des événements passés —
          <span style="text-decoration:underline;cursor:pointer">Afficher</span>
        </div>
      }
    </div>
  `
})
export class CmlHeaderComponent {
  @Input() hasChanges = false;
  @Input() saving = false;
  @Input() changeCount = 0;
  @Input() hidePastEvents = true;
  @Input() pastEventsCount = 0;
  @Input() searchTerm = '';
  @Input() hiddenPastSearchCount = 0;
  @Input() availableLabels: Array<{label: string; color: string; count: number}> = [];
  @Input() selectedLabels: string[] = [];
  @Input() availableSchedules: Array<{key: string; label: string; type: string}> = [];
  @Input() selectedSchedule: string | null = null;
  @Input() nowModeActive = true;
  @Output() saveClick = new EventEmitter<void>();
  @Output() cancelClick = new EventEmitter<void>();
  @Output() togglePast = new EventEmitter<void>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() clearSearch = new EventEmitter<void>();
  @Output() showPastResults = new EventEmitter<void>();
  @Output() toggleLabel = new EventEmitter<string>();
  @Output() selectSchedule = new EventEmitter<string | null>();
  @Output() toggleNowMode = new EventEmitter<void>();

  readonly colorToVar = colorToVar;

  isLabelSelected(label: string): boolean {
    return this.selectedLabels.some(l => l.toLowerCase() === label.trim().toLowerCase());
  }
}
